module.exports = __webpack_public_path__ + "img/upa-logo.3a33c46b.svg";